'use strict';
const	StoreFactory	= require('factories/Store')
		, LocalStorage	= require('providers/LocalStorageProvider');

module.exports = StoreFactory.create({
	displayName : 'Country',
	actions : [
		'add'
	],
	construct : function(){
		if(LocalStorage.get('user.origin')) {
			LocalStorage.remove('user.origin')
		}
		if(LocalStorage.get('user.origin.country')) {
			this.dispatch({
				type : 'COUNTRY_ADD',
				payload : LocalStorage.get('user.origin.country')
			});
		}
	},
	reducer : function(state,action) {

		let dictionary = {};
		let countryList = [];

		switch(action.type) {
		case 'GEOLOCATION_DETECT_SUCCESS' :
			if(action.payload.geoLocation.country.data.id) {

				LocalStorage.set('user.origin.country',action.payload.geoLocation.country.data);

				let obj = {},
					{id,iso,iso3,name,nicename,numcode,phonecode,slug} = action.payload.geoLocation.country.data;
				obj[action.payload.geoLocation.country.data.id] = {id,iso,iso3,name,nicename,numcode,phonecode,slug};

				return Object.assign({},state,obj);
			} else {
				return state;
			}

		case 'COUNTRY_ADD' :
			if(action.payload.id) {
				let obj = {},
					{id,iso,iso3,name,nicename,numcode,phonecode,slug} = action.payload;
				obj[action.payload.id] = {id,iso,iso3,name,nicename,numcode,phonecode,slug};

				return Object.assign({},state,{
					dictionary : Object.assign(state.dictionary,obj)
				});
			} else {
				return state;
			}
		case 'COUNTRY_GET_COUNTRY_BY_SLUG_SUCCESS' :
			return Object.assign({},state,{
				dictionary : Object.assign(state.dictionary,{
					[action.payload.countries.id] : action.payload.countries
				})
			});
		case 'COUNTRY_FETCH_SERVICING_COUNTRIES_SUCCESS':

			action.payload.countries.map((country) => {
				dictionary[country.id] = country;
				countryList.push(country.id);
			});

			return Object.assign({}, state, {
				dictionary: Object.assign({}, state.dictionary, dictionary),
				countryList,
				isLoaded : true
			});

		case 'COUNTRY_GET_HOMESTREAM_FILTER_COUNTRIES_SUCCESS' :
			return Object.assign({},state,{
				homestreamCountryList : action.payload.countries,
				isHomestreamCountriesLoaded : true
			})

		default :
			return state || {
				countryList : [],
				homestreamCountryList : [],
				dictionary : {},
				isLoaded : false,
				isHomestreamCountriesLoaded : false
			};
		}
	}
});



// WEBPACK FOOTER //
// providers/stores/Country.js